import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MediaObserver } from '@angular/flex-layout';
import { filterDateAnim } from 'src/app/models/consts/anims';
import { ToolsService } from 'src/app/services/tools/tools.service';

import { TableReservationClientService } from 'src/app/services/apiclient/table-reservation/table-reservation.service';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';


@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css'],
  animations: [
    filterDateAnim,
  ]
})



export class ReservationComponent implements OnInit {

  @Output() openSideDataEvent = new EventEmitter<any>();
  @Output() setSideDataEvent = new EventEmitter<any>();
  @Output() setSideTypeEvent = new EventEmitter<any>();

  @ViewChild('pageTitle') pageTitle: ElementRef|any;
  @ViewChild(MatPaginator) paginator: MatPaginator|any;
  @ViewChild(MatSort) sort: MatSort|any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['id_booking_level', 'point_of_sale', 'date_reservation', 'hour_execution', 'n_people', 'comment'];

  // Loaders
  loader: boolean = true;
  reservationLoader: boolean = false;

  // Scroll
  titlePositionTop: number|any;

  filterDateAnimFlag: boolean = false;
  get getToggleFilterDate(): string { return this.filterDateAnimFlag ? "show" : "hide"; }

  constructor(
    private media: MediaObserver,
    private reservationApi: TableReservationClientService,
    private tools: ToolsService,
    public dialogService: DialogsService
  ) {
    this.onResp();
  }
  
  ngOnInit() {
    this.tools.setPageClient("bookings");
    this.getBookings();
  }

  getBookings() {
    this.reservationApi.getBookings().subscribe(bookings => {
      setTimeout(() => {
        this.dataSource.data = bookings;
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort;
        this.setTitlePosition();
      });
      this.loader = false;
    });
  }

  setTitlePosition() {
    this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top;
  }

  setBookingLoader($event: boolean) {
    if ($event) {
      this.filterDateAnimFlag = false;
    }
    this.reservationLoader = $event;
  }

  setBookings($event: any) {
    this.dataSource.data = $event;
  }

  onResp() {
    this.media.asObservable().subscribe(media => {
      if (this.titlePositionTop) {
        this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top + 10;
       
      }
    });
  }
  openSnackBar() {
    this.tools.openSnackBar("En attente de confirmation", "secondary", null, "bottom");
  
  }
}
